/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useT } from 'talkr';
import s from './index.module.scss';
import bg4 from './img/short_4.jpg';
import ActionBar from '../../components/actionBar';

function FormingSkill() {
  const { T } = useT();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'IS_STATUSBAR_TRANSPARENT',
      payload: true,
    });
  });

  return (
    <div className={s.formingSkill}>
      <div className={s.formingSkill_text}>
        <div
          className={s.formingSkill_description}
          dangerouslySetInnerHTML={{ __html: T('formingSkill_description') }}
        />
      </div>
      <img className={s.formingSkill_bg} src={bg4} alt={s.welcome} />
      <div className={s.formingSkill_shadow} />
      <ActionBar currentStepCompleted show transparentBg />
    </div>
  );
}

export default FormingSkill;
